import React from "react";
import type { GlossaryId } from "~/generated/glossary.types";
import GlossaryInfoIcon from "~/widgets/GlossaryInfoIcon/GlossaryInfoIcon";
import styles from "~/pages/CharacterSheet/widgets/SkillCardBase/SkillCardBase.scss";

export interface SkillCardBaseProps {
    name: string;
    formula: string;
    poolSize: number;
    glossaryId: GlossaryId;
    onRoll: (name: string, poolSize: number, flatHits?: number) => void;
}

/**
 * SkillCardBase widget for displaying skill check information and roll action.
 * Renders a skill's name, calculation formula, dice pool, and roll button.
 */
const SkillCardBase: React.FC<SkillCardBaseProps> = ({
  name,
  formula,
  poolSize,
  glossaryId,
  onRoll,
}) => {
  return (
    <>
      <button
        type="button"
        onClick={() => {
          onRoll(name, poolSize);
        }}
        className={styles.skillCard}
      >
        <div className={styles.skillInfo}>
          <h3 className={styles.skillName}>
            {name}
            <GlossaryInfoIcon glossaryId={glossaryId} className={styles.infoIcon} />
          </h3>
          <span className={styles.skillFormula}>{formula}</span>
        </div>
        <span className={styles.poolDisplay}>{poolSize}d6</span>
      </button>
    </>
  );
};

export default SkillCardBase;
